<div [ngClass]="hideBackground ? 'journey-service--padded' : 'journey-service'" *ngIf="navigationDetails?.length > 0 && isShowJourneyNav">
  <hr class="divider" [ngClass]="hideBackground ? '' : 'divider--footer'">
  <div class="journey-service__container"
    [attr.data-analytics-component-name]="'Journey navigation'">
    <ng-container *ngFor="let btn of buttons">
      <button *ngIf="!btn.isHidden && !(btn.id === 'cancelRenewel' && urlHasParam)"
              dlg-button
              appCancelFocus
              size="toolbar"
              id="{{ btn.id }}"
              [theme]="btn.theme"
              [disabled]="btn.isDisabled"
              [class]="btn.css"
              (click)="onButtonClick(btn.onClick, $event)"
              [ngStyle]="btn.visibleOrder && {'order': btn.visibleOrder}">
        {{ btn.label }}
      </button>
    </ng-container>
  </div>
</div>
